module.exports = __webpack_public_path__ + "static/Reduction_Primary_mobile-98ada85df284b43fc10546f3afebb58e.png";